import * as actionTypes from '../constants/actionTypes';
import { updateObject } from '../../../../shared/utils/index';

const initialState = {
  noteTemplates: null,
  noteTemplatesLoading: false,
  noteTemplatesError: null,
  noteDispositions: null,
  noteDispositionsLoading: false,
  noteDispositionsError: null,
  insureds: null,
  insuredsLoading: false,
  insuredsError: null,
  policies: null,
  policiesLoading: false,
  policiesError: null,
  claims: null,
  claimsLoading: false,
  claimsError: null,
  tasks: null,
  tasksLoading: false,
  tasksError: null,
  noteTypes: null,
  noteTypesLoading: false,
  noteTypesError: null,
  noteTypesCreateLoading: false,
  contactPhones: null,
  contactPhonesLoading: false,
  contactPhonesError: null,
};

const getNoteTemplatesStart = (state, action) => {
  return updateObject(state, {
    noteTemplates: null,
    noteTemplatesLoading: true,
  });
};

const getNoteTemplatesSuccess = (state, action) => {
  return updateObject(state, {
    noteTemplates: action.noteTemplates,
    noteTemplatesError: null,
    noteTemplatesLoading: false,
  });
};

const getNoteTemplatesFail = (state, action) => {
  return updateObject(state, {
    noteTemplates: null,
    noteTemplatesError: action.error,
    noteTemplatesLoading: false,
  });
};

const getNoteDispositionsStart = (state, action) => {
  return updateObject(state, {
    noteDispositions: null,
    noteDispositionsLoading: true,
  });
};

const getNoteDispositionsSuccess = (state, action) => {
  return updateObject(state, {
    noteDispositions: action.noteDispositions,
    noteDispositionsError: null,
    noteDispositionsLoading: false,
  });
};

const getNoteDispositionsFail = (state, action) => {
  return updateObject(state, {
    noteDispositions: null,
    noteDispositionsError: action.error,
    noteDispositionsLoading: false,
  });
};

const getInsuredsStart = (state, action) => {
  return updateObject(state, {
    insuredsLoading: true,
  });
};

const getInsuredsSuccess = (state, action) => {
  return updateObject(state, {
    insureds: action.insureds,
    insuredsError: null,
    insuredsLoading: false,
  });
};

const getInsuredsFail = (state, action) => {
  return updateObject(state, {
    insureds: null,
    insuredsError: action.error,
    insuredsLoading: false,
  });
};

const getPoliciesStart = (state, action) => {
  return updateObject(state, {
    policiesLoading: true,
  });
};

const getPoliciesSuccess = (state, action) => {
  return updateObject(state, {
    policies: action.policies,
    policiesError: null,
    policiesLoading: false,
  });
};

const getPoliciesFail = (state, action) => {
  return updateObject(state, {
    policies: null,
    policiesError: action.error,
    policiesLoading: false,
  });
};

const getTasksStart = (state, action) => {
  return updateObject(state, {
    tasksLoading: true,
  });
};

const getTasksSuccess = (state, action) => {
  return updateObject(state, {
    tasks: action.tasks,
    tasksError: null,
    tasksLoading: false,
  });
};

const getTasksFail = (state, action) => {
  return updateObject(state, {
    tasks: null,
    tasksError: action.error,
    tasksLoading: false,
  });
};

const getClaimsStart = (state, action) => {
  return updateObject(state, {
    claimsLoading: true,
  });
};

const getClaimsSuccess = (state, action) => {
  return updateObject(state, {
    claims: action.claims,
    claimsError: null,
    claimsLoading: false,
  });
};

const getClaimsFail = (state, action) => {
  return updateObject(state, {
    claims: null,
    claimsError: action.error,
    claimsLoading: false,
  });
};

const getNoteTypesStart = (state, action) => {
  return updateObject(state, {
    noteTypesLoading: true,
  });
};

const getNoteTypesSuccess = (state, action) => {
  return updateObject(state, {
    noteTypes: action.noteTypes,
    noteTypesError: null,
    noteTypesLoading: false,
  });
};

const getNoteTypesFail = (state, action) => {
  return updateObject(state, {
    noteTypes: null,
    noteTypesError: action.error,
    noteTypesLoading: false,
  });
};

const createNoteTypeStart = (state, action) => {
  return updateObject(state, {
    error: null,
    noteTypesCreateLoading: true,
  });
};

const createNoteTypeSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    noteTypesCreateLoading: false,
  });
};

const createNoteTypeFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    noteTypesCreateLoading: false,
  });
};

const getContactPhonesStart = (state, action) => {
  return updateObject(state, {
    contactPhones: null,
    contactPhonesLoading: true,
  });
};

const getContactPhonesSuccess = (state, action) => {
  return updateObject(state, {
    contactPhones: action.contactPhones,
    contactPhonesError: null,
    contactPhonesLoading: false,
  });
};

const getContactPhonesFail = (state, action) => {
  return updateObject(state, {
    contactPhones: null,
    contactPhonesError: action.error,
    contactPhonesLoading: false,
  });
};

const getReminderEmailsStart = (state, action) => {
  return updateObject(state, {
    reminderEmails: null,
    reminderEmailsLoading: true,
  });
};

const getReminderEmailsSuccess = (state, action) => {
  return updateObject(state, {
    reminderEmails: action.reminderEmails,
    reminderEmailsError: null,
    reminderEmailsLoading: false,
  });
};

const getReminderEmailsFail = (state, action) => {
  return updateObject(state, {
    reminderEmails: null,
    reminderEmailsError: action.error,
    reminderEmailsLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_NOTE_TEMPLATES_START:
      return getNoteTemplatesStart(state, action);
    case actionTypes.GET_NOTE_TEMPLATES_SUCCESS:
      return getNoteTemplatesSuccess(state, action);
    case actionTypes.GET_NOTE_TEMPLATES_FAIL:
      return getNoteTemplatesFail(state, action);

    case actionTypes.GET_NOTE_DISPOSITIONS_START:
      return getNoteDispositionsStart(state, action);
    case actionTypes.GET_NOTE_DISPOSITIONS_SUCCESS:
      return getNoteDispositionsSuccess(state, action);
    case actionTypes.GET_NOTE_DISPOSITIONS_FAIL:
      return getNoteDispositionsFail(state, action);

    case actionTypes.GET_POLICIES_START:
      return getPoliciesStart(state, action);
    case actionTypes.GET_POLICIES_SUCCESS:
      return getPoliciesSuccess(state, action);
    case actionTypes.GET_POLICIES_FAIL:
      return getPoliciesFail(state, action);

    case actionTypes.GET_TASKS_START:
      return getTasksStart(state, action);
    case actionTypes.GET_TASKS_SUCCESS:
      return getTasksSuccess(state, action);
    case actionTypes.GET_TASKS_FAIL:
      return getTasksFail(state, action);

    case actionTypes.GET_CLAIMS_START:
      return getClaimsStart(state, action);
    case actionTypes.GET_CLAIMS_SUCCESS:
      return getClaimsSuccess(state, action);
    case actionTypes.GET_CLAIMS_FAIL:
      return getClaimsFail(state, action);

    case actionTypes.GET_NOTE_TYPES_START:
      return getNoteTypesStart(state, action);
    case actionTypes.GET_NOTE_TYPES_SUCCESS:
      return getNoteTypesSuccess(state, action);
    case actionTypes.GET_NOTE_TYPES_FAIL:
      return getNoteTypesFail(state, action);

    case actionTypes.GET_INSUREDS_PROSPECTS_START:
      return getInsuredsStart(state, action);
    case actionTypes.GET_INSUREDS_PROSPECTS_SUCCESS:
      return getInsuredsSuccess(state, action);
    case actionTypes.GET_INSUREDS_PROSPECTS_FAIL:
      return getInsuredsFail(state, action);

    case actionTypes.CREATE_NOTE_TYPE_START:
      return createNoteTypeStart(state, action);
    case actionTypes.CREATE_NOTE_TYPE_SUCCESS:
      return createNoteTypeSuccess(state, action);
    case actionTypes.CREATE_NOTE_TYPE_FAIL:
      return createNoteTypeFail(state, action);

    case actionTypes.GET_CONTACT_PHONES_START:
      return getContactPhonesStart(state, action);
    case actionTypes.GET_CONTACT_PHONES_SUCCESS:
      return getContactPhonesSuccess(state, action);
    case actionTypes.GET_CONTACT_PHONES_FAIL:
      return getContactPhonesFail(state, action);

    case actionTypes.GET_REMINDER_EMAILS_START:
      return getReminderEmailsStart(state, action);
    case actionTypes.GET_REMINDER_EMAILS_SUCCESS:
      return getReminderEmailsSuccess(state, action);
    case actionTypes.GET_REMINDER_EMAILS_FAIL:
      return getReminderEmailsFail(state, action);

    default:
      return state;
  }
};

export default reducer;
